enum ChartColors {
    plum500 = "#b6265d",
    mustard500 = "#eec430",
    mint300 = "#63b08b",
    mint500 = "#6AF0B0",
    pine500 = "#33656a",
    pine700 = "#94b2b4",
    pine800 = "#d8dede",
    tango500 = "#ee7930",
    midnight500 = "#1b3f50",

    // Specific colors we added for charts
    chartBlue = "#5674cb",
    chartPink = "#a15786",
    chartMud = "#6c5d10",
    chartDustyBlue = "#4d8aa4",
    chartHotPink = "#cc1a78",
    chartHotPurple = "#820de2",
    chartElectricBlue = "#0d49e2",
    chartBlowyourEyesOffGreen = "#0de25e",
    chartHotOrange = "#e2a10d",
    chartHotYellow = "#e2d10d",
    chartHotRed = "#e20d0d",
    chartHotBrown = "#a16c0d",
}

// enum to array
export const ChartColorsArray = Object.keys(ChartColors).map((key) => ChartColors[key]);

export default ChartColors;
